/**
 *
 * DocumentsPageContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { makeSelectRoles, makeSelectAccountId } from 'domain/User/selectors';

import getDocumentsPage from './getDocumentsPage';
import saga from './sagas';
import {makeSelectBreakpoint} from "../../domain/Screen/selectors";

export class DocumentsPageContainer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const { accountId, userRoles, ...restProps } = this.props;
    const { view: viewName = 'all' } = queryString.parse(this.props.location.search);
    const props = { viewName, userRoles, ...restProps };

    return getDocumentsPage(accountId, props);
  }
}

DocumentsPageContainer.propTypes = {
  location: PropTypes.object.isRequired,
  accountId: PropTypes.string,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = createStructuredSelector({
  accountId: makeSelectAccountId(),
  userRoles: makeSelectRoles(),
  breakpoint: makeSelectBreakpoint(),
});

const reducer = (state = {}) => state;
const withReducer = injectReducer({ key: 'documentPage', reducer });
const withSaga = injectSaga({ key: 'documentPage', saga });
const withConnect = connect(mapStateToProps);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(DocumentsPageContainer);
